// 1. 引入对应模块
import Vue from "vue";
import VueRouter from "vue-router";

/* 解决路由命名冲突的方法---start */
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return routerPush.call(this, location, onResolve, onReject);
  return routerPush.call(this, location).catch((error) => error);
};
const routerReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch((err) => err);
};
/* 解决路由命名冲突的方法---end */
// 异步组件加载Admin_Home

const Login = () => import("../views/Login/index.vue"); //登录界面
const Forget = () => import("../views/Login/forget.vue"); //忘记密码
const Error = () => import("../views/Error/index.vue"); // 404界面
// 用户端
const User = () => import("../views/User"); //父组件
const UserInfo = () => import("../views/User/Children/users/index.vue"); //父组件
// 管理员端
const Admin = () => import("../views/Admin"); //父组件
const AdminHome = () => import("../views/Admin/Children/index.vue"); //默认首页子组件
const AdminInfo = () => import("../views/Admin/Children/users/Info.vue"); //个人中心
const Users = () => import("../views/Admin/Children/users/index.vue"); //用户管理
const UserParamsList = () =>
  import("../views/Admin/Children/users/paramsList.vue"); //用户参数管理
const UserSettingParams = () =>
  import("../views/Admin/Children/users/settingParams.vue"); //用户参数管理
const Integral = () => import("../views/Admin/Children/users/integral.vue"); //积分记录管理
const Account = () => import("../views/Admin/Children/resource/account.vue"); //账号列表
const Personnel = () =>
  import("../views/Admin/Children/resource/personnel.vue"); //人才列表
const Film = () => import("../views/Admin/Children/resource/film.vue"); //影视列表
const SportsList = () =>
  import("../views/Admin/Children/antForest/sportsList.vue"); //运动列表
const UserAccount = () =>
  import("../views/Admin/Children/antForest/userAccount.vue"); //用户运动列表
const WaitUser = () => import("../views/Admin/Children/antForest/waitUser.vue"); //排队运动列表
const WaitAccount = () =>
  import("../views/Admin/Children/antForest/waitAccount.vue"); //等待运动列表
const CacheAccount = () =>
  import("../views/Admin/Children/antForest/cacheAccount.vue"); //缓存运动列表
const AntsList = () => import("../views/Admin/Children/antForest/antsList.vue"); //蚂蚁列表
const ZeppList = () => import("../views/Admin/Children/antForest/zeppList.vue"); //Zepp列表
const SpeciesList = () =>
  import("../views/Admin/Children/antForest/speciesList.vue"); //合种列表
const KeyList = () => import("../views/Admin/Children/system/key.vue"); //秘钥列表
const LogsList = () => import("../views/Admin/Children/system/logs.vue"); //日志列表
const PlanList = () => import("../views/Admin/Children/system/plan.vue"); //任务列表
const ParamsList = () => import("../views/Admin/Children/system/params.vue"); //参数列表
const SettingParams = () =>
  import("../views/Admin/Children/system/settingParams.vue"); //参数设置
const Codebase = () => import("../views/Admin/Children/system/codebase.vue"); //代码库
const Notice = () => import("../views/Admin/Children/system/notice.vue"); //通知公告
// 2. 声明使用
Vue.use(VueRouter);

// 3. 配置路由规则
const routes = [
  { path: "/login", component: Login },
  { path: "/forget", component: Forget },
  { path: "/", redirect: "/mange" }, //路由重定向
  {
    path: "/mange",
    name: "Admin",
    component: Admin,
    children: [
      // /admin路由下的二级路由==>拼接全路由为：/admin/home
      { path: "home", component: AdminHome },
      { path: "info", name: "管理员信息", component: AdminInfo },
      { path: "users", component: Users },
      { path: "usersParamsList", component: UserParamsList },
      { path: "userSetting", component: UserSettingParams },
      { path: "integral", component: Integral },
      { path: "account", component: Account },
      { path: "personnel", component: Personnel },
      { path: "film", component: Film },
      { path: "sports", name: "运动列表", component: SportsList },
      { path: "userAccount", name: "用户运动列表", component: UserAccount },
      { path: "waitUser", name: "排队运动列表", component: WaitUser },
      { path: "waitAccount", name: "等待运动列表", component: WaitAccount },
      { path: "cacheAccount", name: "缓存运动列表", component: CacheAccount },
      { path: "ants", name: "蚂蚁列表", component: AntsList },
      { path: "species", name: "合种列表", component: SpeciesList },
      { path: "zepp", name: "zepp列表", component: ZeppList },
      { path: "key", name: "秘钥列表", component: KeyList },
      { path: "logs", name: "日志列表", component: LogsList },
      { path: "plan", name: "任务列表", component: PlanList },
      { path: "params", name: "参数列表", component: ParamsList },
      { path: "setParams", name: "参数设置", component: SettingParams },
      { path: "codebase", name: "代码库", component: Codebase },
      { path: "notice", name: "通知公告", component: Notice },
      { path: "/mange", redirect: "/mange/home" }, //路由重定向
    ],
    // 需要守卫
    meta: {
      login: true, //需要登录
      auth: true, //需要管理员权限
    },
  },
  {
    path: "/public",
    name: "User",
    component: User,
    children: [
      { path: "home", component: UserInfo },
      { path: "info", name: "个人中心", component: UserInfo },
      { path: "/public", redirect: "/public/info" }, //路由重定向
    ],
    // 需要守卫
    meta: {
      login: true, //需要登录
    },
  },
  //404界面
  {
    path: "/notfound",
    name: "页面不存在",
    component: Error,
    meta: { hideHeaderNav: true, hideHeaderTop: true },
  },
  {
    path: "*", // 页面不存在的情况下会跳到404页面
    redirect: "/notfound",
    name: "notFound",
    hidden: true,
  },
];
// 4. 导出路由对象
export default new VueRouter({ routes });
